import React from "react";
import { AppBar, Toolbar, Typography, Box } from "@mui/material";
import { Link } from "react-router-dom";

const Header = ({ onContactClick }) => {
	return (
		<AppBar
			position="static"
			sx={{ backgroundColor: "primary.main", boxShadow: "none" }}
			disableGutters
		>
			<Toolbar sx={{ justifyContent: "space-between" }} disableGutters>
				<Typography
					variant="h5"
					component="div"
					color="text.primary"
					sx={{ margin: 0, padding: 0 }}
				>
					<Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
						<span style={{ textDecoration: "underline", cursor: "pointer" }}>
							Morris Ho
						</span>
					</Link>
				</Typography>
				<Box sx={{ display: "flex", gap: 2 }}>
					<Typography
						variant="h6"
						component="div"
						color="text.primary"
						sx={{ margin: 0, padding: 0 }}
					>
						<Link
							to="/blog"
							style={{ textDecoration: "none", color: "inherit" }}
						>
							<span style={{ textDecoration: "underline", cursor: "pointer" }}>
								Blog
							</span>
						</Link>
					</Typography>
					<Typography
						variant="h6"
						component="div"
						color="text.primary"
						sx={{ margin: 0, padding: 0 }}
					>
						<span
							style={{
								textDecoration: "underline",
								cursor: "pointer",
								color: "inherit"
							}}
							onClick={onContactClick}
						>
							Contact
						</span>
					</Typography>
				</Box>
			</Toolbar>
		</AppBar>
	);
};

export default Header;
